import { NgModule } from '@angular/core';

import { ColumnAutosizeVirtualScrollDirective } from './column-autosize-strategy';
import { RowAutosizeVirtualScrollDirective } from './flexible-strategy';
import { ScrollSyncDirective } from './scroll-sync.directive';
import { StickyDirective } from './sticky.directive';
import { BlazeVirtualScrollableElementDirective } from './virtual-scrollable-element.directive';

@NgModule({
  imports: [StickyDirective],
  declarations: [
    ColumnAutosizeVirtualScrollDirective,
    BlazeVirtualScrollableElementDirective,
    RowAutosizeVirtualScrollDirective,
    ScrollSyncDirective,
  ],
  exports: [
    ColumnAutosizeVirtualScrollDirective,
    BlazeVirtualScrollableElementDirective,
    RowAutosizeVirtualScrollDirective,
    StickyDirective,
    ScrollSyncDirective,
  ],
})
export class VirtualScrollModule {}
